import { AutoComplete, Form, FormProps, Input, Select } from 'antd';
import React, { useMemo } from 'react';

import { useGetEventCategory } from '@api/emp/queryHooks';
import { EPanelOpenMethod } from '@components/block-event-single/store';
import {
  validateMappedEventMismatch,
  validateMappedEventName,
} from '@src/emp-3.0/domain/mapped-event';
import { MappedEvent } from '@src/emp-3.0/types';

const EventInfoForm: React.FC<
  FormProps & { mode?: EPanelOpenMethod; mappedEvent?: MappedEvent }
> = (formProps) => {
  const { mode } = formProps;

  const { data: categoryData } = useGetEventCategory();

  const isViewMode = useMemo(() => mode === EPanelOpenMethod.VIEW, [mode]);
  const isCloneMode = useMemo(() => mode === EPanelOpenMethod.CLONE, [mode]);

  const categoryItems = useMemo(() => {
    return categoryData?.data?.map((v) => {
      return { label: v.category_name, value: v.category_name };
    });
  }, [categoryData]);

  return (
    <Form labelCol={{ flex: '120px' }} labelAlign="left" {...formProps}>
      <Form.Item
        name="event_name"
        label="Mapped Name"
        required={false}
        dependencies={['event_category']}
        rules={[
          { required: true, message: 'required!' },
          ({ getFieldValue }) => ({
            validator(_, value) {
              const { failed, message } = validateMappedEventName(value);
              const isMatch = validateMappedEventMismatch(
                value,
                getFieldValue('event_category'),
                categoryData?.data,
              );
              if (value && failed) {
                return Promise.reject(new Error(message));
              } else if (isMatch) {
                return Promise.reject(new Error('Pre-defined name and category mismatched'));
              }

              return Promise.resolve();
            },
          }),
        ]}
      >
        <AutoComplete disabled={isViewMode} bordered={!isViewMode} placeholder="Please input..." />
      </Form.Item>
      <Form.Item
        name="event_category"
        label="Event Category"
        dependencies={['event_name']}
        required={false}
        rules={[
          { required: true, message: 'required!' },
          ({ getFieldValue }) => ({
            validator(_, value) {
              const isMatch = validateMappedEventMismatch(
                getFieldValue('event_name'),
                value,
                categoryData?.data,
              );
              if (isMatch) {
                return Promise.reject(new Error('Pre-defined name and category mismatched'));
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <Select
          disabled={isViewMode}
          bordered={!isViewMode}
          showArrow={!isViewMode}
          options={categoryItems}
          placeholder="Please Select..."
        />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <Input.TextArea
          bordered={!isViewMode}
          style={{ resize: 'none' }}
          placeholder="Add a note..."
          autoSize
        />
      </Form.Item>
    </Form>
  );
};

export default EventInfoForm;
